// extracted by mini-css-extract-plugin
export default {"row":"Home_row__5J2LA","col":"Home_col__i+61g","card":"Home_card__XV3OF"};